import { FieldEditorProps } from './FieldEditorProps';
import AsyncSelect from 'Shared/components/AsyncSelect'
import ColorCodeOption from './components/ColorCodeOption'
import '../styles/Editors.scoped.scss';

export const SearchFieldEditor = ({ field, onChange }: FieldEditorProps) => {
  return <>
    <div className="field-editor-row">
      <label>Audience</label>
      <div className='field-editor-input'>
        <AsyncSelect
          entity="search"
          value={field?.searchId}
          rootClassName="grow"
          onChange={(id) => onChange({ searchId: id })}
        />
      </div>
    </div>
    <ColorCodeOption field={field} onChange={onChange} />
  </>
}
